import styled from 'styled-components';
import { Colors, FontLineHeight, FontSize, FontWeight, Spacing } from 'web-common/src/shared/styles';
import { DynamicImage } from '../DynamicImage';

export const SHEF_NAME_LINE_HEIGHT = parseInt(FontLineHeight.M, 10);

export const SHEF_IMAGE_DIMENSIONS = 64;

export const ShefName = styled.span`
  font-size: ${FontSize.S};
  line-height: ${SHEF_NAME_LINE_HEIGHT}px;
  font-weight: ${FontWeight.BOLD};
  color: ${Colors.GRAY_DARK_30};
  margin: ${Spacing.EIGHTH} 0 0;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const ShefDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ShefImage = styled(DynamicImage)<{ sourceWidth?: number; sourceHeight?: number }>`
  min-width: ${SHEF_IMAGE_DIMENSIONS}px;
  height: ${({ sourceHeight }) => sourceHeight ?? SHEF_IMAGE_DIMENSIONS}px;
  width: ${({ sourceWidth }) => sourceWidth ?? SHEF_IMAGE_DIMENSIONS}px;
  border-radius: 100%;
`;

export const CuisineListing = styled.span`
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.MEDIUM};
  color: ${Colors.GRAY_DARK_10};

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const TagContainer = styled.div`
  margin-top: ${Spacing.QUARTER};
  margin-bottom: ${Spacing.QUARTER};
  display: flex;
  gap: ${Spacing.HALF};
  height: ${Spacing.SINGLE_HALF};
`;

export const NumDishesOrDeliveryPriceContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NumDishesOrDeliveryFeeText = styled(CuisineListing)`
  font-style: italic;
`;
